export const LABELS = {
  ENTITY_NAME: "[placeholder]",
  // Add other configurable labels here as needed
};